<script setup>
// @ts-check
import ChipIcon from '@/components/icons/ChipIcon.vue'
import { withVariant } from '@/core/props'

defineProps({
  text: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: null
  },
  variant: withVariant('primary')
})

defineOptions({
  name: 'StatusBadge'
})
</script>

<template>
  <VChip
    class="status-badge h-7! min-w-fit! px-2.5! select-none"
    :class="`status-badge-${variant}`"
    variant="outlined"
  >
    <span v-if="text" class="font-semibold">
      {{ text }}
    </span>

    <template v-if="icon" #prepend>
      <ChipIcon :name="icon" class="status-badge-icon mr-2" />
    </template>
  </VChip>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.status-badge {
  &:has(.status-badge-icon) {
    @apply pl-1.5!;
  }
}

.status-badge-primary {
  @apply border-primary-100 bg-primary-50 text-primary-800;

  .status-badge-icon {
    @apply bg-primary-800;
  }
}

.status-badge-success {
  @apply border-success-100 bg-success-50 text-success-800;

  .status-badge-icon {
    @apply bg-success-800;
  }
}

.status-badge-info {
  @apply border-blue-100 bg-blue-50 text-blue-800;

  .status-badge-icon {
    @apply bg-blue-800;
  }
}

.status-badge-danger {
  @apply border-danger-100 bg-danger-50 text-danger-800;

  .status-badge-icon {
    @apply bg-danger-800;
  }
}
</style>
